import { render, staticRenderFns } from "./CompanyCreate.vue?vue&type=template&id=e5d60872&scoped=true&"
import script from "./CompanyCreate.vue?vue&type=script&lang=js&"
export * from "./CompanyCreate.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCreate.vue?vue&type=style&index=0&id=e5d60872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d60872",
  null
  
)

export default component.exports